import Modal from "react-bootstrap/Modal";

import "./style.css";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { apiEditBuyer } from "../../../api/master";
// import { apiCity, apiState } from "../../../api/stateAndCity";
import buyerSchema from "../../../validations/buyerSchema";

function BuyerEdit(props) {
  // const [stateValue, setStateValue] = useState([]);
  // const [city, setCity] = useState([]);
  const [isSubmit, setIsSubmit] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [shownew, setShownew] = useState(false);

  // async function getStateAndCity() {
  //   await apiState().then((result) => setStateValue(result.data.data.list));
  //   await apiCity().then((result) => setCity(result?.data?.data.list));
  // }

  // useEffect(function () {
  //   getStateAndCity();
  // }, []);

  const BuyerFormik = useFormik({
    initialValues: {
      buyer_id: props.id?.buyer_id,
      buyer_name: props.id?.buyer_name,
      buyer_address: props.id?.buyer_address,
      // buyer_state_id: props.id?.buyer_state_id,
      // buyer_city_id: props.id?.buyer_city_id,
      // buyer_pincode: props.id?.buyer_pincode,
    },
    validationSchema: buyerSchema.validateBuyerEdit(),
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (values) => {
      values = {
        buyer_id: Number(values.buyer_id),
        buyer_name: values.buyer_name,
        buyer_address: values.buyer_address,
        // buyer_state_id: Number(values.buyer_state_id),
        // buyer_city_id: Number(values.buyer_city_id),
        // buyer_pincode: Number(values.buyer_pincode)
      };
      setIsSubmit(true);
      await apiEditBuyer(values)
        .then((data) => {
          setSuccess(data.data.message);
          setError("");
          props.list();
        })
        .catch((err) => {
          setError(err.response.data.data.message);
          setSuccess("");
        })
        .finally((result) => {
          setIsSubmit(false);
          setTimeout(() => {
            setSuccess("");
            setError("");
          }, 5000);
        });
    },
  });

  // const stateListMap = stateValue?.flatMap((el) => {
  //   return {
  //     value: el?.state_id,
  //     label: el.name,
  //   };
  // });

  // let filterCityName = city?.filter(
  //   (el) => Number(el?.state_id) === Number(BuyerFormik.values.buyer_state_id)
  // );

  // const cityListMap = filterCityName?.flatMap((el) => {
  //   return {
  //     value: el?.city_id,
  //     label: el.city,
  //   };
  // });

  useEffect(function () {}, [success, error]);

  return (
    <>
      <Modal.Header closeButton>
        <h4 style={{ marginLeft: "10rem", height: "4px" }} id="modalhead">
          Edit Supplier
        </h4>
      </Modal.Header>
      <div className="container-fluid p-4" id="buyerAdd">
        <form
          className="row gx-5 gy-2"
          onSubmit={BuyerFormik.handleSubmit}
          autoComplete="off"
        >
          <div className="col-md-6">
            <label htmlFor="buyer_name">
              Supplier Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              id="buyer_name"
              {...BuyerFormik.getFieldProps("buyer_name")}
            />
            {BuyerFormik.errors.buyer_name && shownew != true ? (
              <div className="text-danger small">
                {BuyerFormik.errors.buyer_name}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="buyer_address">Supplier Address</label>
            <textarea
              type="text"
              maxLength={100}
              className="form-control"
              id="buyer_address"
              {...BuyerFormik.getFieldProps("buyer_address")}
            />
          </div>
          {/* <div className="col-md-6">
            <label htmlFor="buyer_state_id">
              State <span className="text-danger">*</span>
            </label>
            <select
            name="select"
              className="form-select"
              id="state_id"
              {...BuyerFormik.getFieldProps("buyer_state_id")}
            >
              <option hidden>Select...</option>
              {stateListMap?.map((list) => (
                <option value={list.value}>{list.label}</option>
              ))}
            </select>
            {BuyerFormik.errors.buyer_state_id && shownew != true ? (
              <div className="text-danger small">
                {BuyerFormik.errors.buyer_state_id}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="buyer_city_id">
              City <span className="text-danger">*</span>
            </label>
            <select
              className="form-select"
              id="city_id"
              {...BuyerFormik.getFieldProps("buyer_city_id")}
            >
              <option hidden>Select...</option>
              {cityListMap?.map((list) => (
                <option value={list.value}>{list.label}</option>
              ))}
            </select>
            {BuyerFormik.errors.buyer_city_id && shownew != true ? (
              <div className="text-danger small">
                {BuyerFormik.errors.buyer_city_id}
              </div>
            ) : null}
          </div> */}
          {/* <div className="col-md-6">
            <label htmlFor="buyer_pincode">
              Pincode <span className="text-danger">*</span>
            </label>
            <input
              type="number"
              maxLength={9}
              className="form-control"
              id="buyer_pincode"
              {...BuyerFormik.getFieldProps("buyer_pincode")}
            />
            {BuyerFormik.errors.buyer_pincode && shownew != true ? (
              <div className="text-danger small">
                {BuyerFormik.errors.buyer_pincode}
              </div>
            ) : null}
          </div> */}
          <div className="col-12 mt-4">
            {(error || success) && (
              <div
                className={`alert alert-${
                  error ? "danger" : "success"
                } py-2 small`}
                role="alert"
              >
                {error || success || ""}
              </div>
            )}
            <div
              style={{
                height: "33px",
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
                float: "right",
              }}
            >
              <button
                className="branchModalCancel"
                onClick={props.hide}
                type="button"
                style={{
                  height: "33px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  float: "right",
                }}
              >
                Cancel
              </button>
              {shownew ? (
                <button
                  id="createNew"
                  onClick={() => {
                    BuyerFormik.resetForm();
                    setShownew(false);
                    setSuccess("");
                  }}
                  style={{
                    height: "33px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    float: "right",
                  }}
                >
                  Add New
                </button>
              ) : (
                <button
                  type="submit"
                  disabled={isSubmit}
                  style={{
                    height: "33px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    float: "right",
                  }}
                >
                  {isSubmit && (
                    <span className="spinner-border spinner-border-sm me-2"></span>
                  )}
                  Save
                </button>
              )}
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default BuyerEdit;
